import S from '../../../combosDrawsTemplate/settings'

export const prepareCustomTraceObj = ({
	currentTrainerState,
	players,
	player,
	actionType,
	query,
	playerAction,
	isBoard,
	pot,
	startPot,
	combosOrder,
}) => {
	const actions_ev = !isBoard && players[player].actions.map((el) => el.ev[players[player].handIndex])
	const actions_played = !isBoard && players[player].actions.map((el) => el.played[players[player].handIndex])
	const actions_gto_range = !isBoard && players[player].actions.map(({ gto_range }) => gto_range)

	const realQuery = isBoard
		? query
				.split('_')
				.filter((el, i) => i !== query.split('_').length - 1)
				.join('_')
		: query

	const getComboName = () => {
		let combo = ''

		const combos = combosOrder === 'FH_FL' ? S.COMBOS_HAND_LINE : S.COMBOS

		for (let i = 0; i < combos.length; i++) {
			if (currentTrainerState.combos[players[player].handIndex] === i) {
				combo = combos[i]
			}
		}

		return combo
	}
	const getDrawName = () => {
		let draw = ''
		for (let i = 0; i < S.DRAWS.length; i++) {
			if (currentTrainerState.draws[players[player].handIndex] === i) {
				draw = S.DRAWS[i]
			}
		}

		return draw
	}

	const maxEv =
		!isBoard &&
		actions_ev.reduce((acc, val) => {
			return acc > val ? acc : val
		})

	const actionEv =
		!isBoard && players[player].actions.find((el) => el.action === playerAction).ev[players[player].handIndex]

	const customTraceObj = {}

	customTraceObj.type = actionType
	customTraceObj.is_ev = true
	customTraceObj.query = realQuery
	customTraceObj.choose = !isBoard ? players[player].actions.map(({ action }) => action).indexOf(playerAction) : 0
	customTraceObj.player = !isBoard ? players[player].index : -1
	customTraceObj.actions = !isBoard ? players[player].actions.map(({ action }) => action) : []
	customTraceObj.diff_ev = !isBoard ? maxEv - actionEv : 0
	customTraceObj.diff_bet = 0
	customTraceObj.hand_draw = !isBoard ? getDrawName() : ''
	customTraceObj.is_played = !isBoard
	customTraceObj.actions_ev = actions_ev
	customTraceObj.hand_combo = !isBoard ? getComboName() : ''
	customTraceObj.tree_query = realQuery
	customTraceObj.current_bet = !isBoard ? '' : 0
	customTraceObj.is_gto_freq = false
	customTraceObj.real_action = playerAction
	customTraceObj.tree_action = playerAction
	customTraceObj.analyze_time = 0
	customTraceObj.is_gto_range = true
	customTraceObj.is_bad_branch = false
	customTraceObj.actions_played = !isBoard ? actions_played : null
	customTraceObj.trace_diff_bet = ''
	customTraceObj.current_real_pot = pot
	customTraceObj.actions_gto_range = !isBoard ? actions_gto_range : null
	customTraceObj.current_start_pot = startPot
	customTraceObj.current_abs_played = 0
	customTraceObj.cumulative_diff_bet = 0
	customTraceObj.current_abs_opp_gto_freq = 0
	customTraceObj.current_abs_opp_gto_range = 0
	customTraceObj.isPlayedLine = false

	return customTraceObj
}

export const prepareSummary = ({
	player,
	heroActivePlayer,
	fLine,
	rLine,
	tLine,
	prLine,
	players,
	startStack,
	endStack,
	isFold = false,
}) => {
	const summary = {}

	summary.hero = player === heroActivePlayer
	summary.seat = false
	summary.cards = players[player]?.hand.join('') ?? null
	summary.f_line = fLine === '' ? null : fLine
	summary.isFold = isFold
	summary.player = player === heroActivePlayer ? `HERO` : `VILLAIN`
	summary.r_line = rLine === '' ? null : rLine
	summary.sitout = false
	summary.t_line = tLine === '' ? null : tLine
	summary.pr_line = prLine === '' ? null : prLine
	summary.endStack = Number(endStack) //
	summary.flopSDEV = 0
	summary.position = `${player}`
	summary.summSDEV = 0
	summary.turnSDEV = 0
	summary.riverSDEV = 0
	summary.deltaStack = Number(endStack) - Number(startStack)
	summary.preFlopSDEV = 0
	summary.endNormStack = Number(endStack)
	summary.startingStack = Number(startStack)
	summary.deltaNormStack = Number(endStack) - Number(startStack)
	summary.startingNormStack = Number(startStack)

	return summary
}
